import { FacilityStatus, PagedRequestDto } from '@umss/shared/data-access';

export interface FacilityAdminSearchDto extends PagedRequestDto {
  facilityTypeId?: number | null;
  location?: string | null;
  status?: FacilityStatus | null;
  registeredDateFrom?: string | null; // DateTime as ISO string
  registeredDateTo?: string | null; // DateTime as ISO string
  hasActiveShifts?: boolean | null;
  bedCountFrom?: number | null;
  bedCountTo?: number | null;
}
